/* unplugin-vue-components disabled */import { render } from "./item-mcq-mmcq.vue?vue&type=template&id=e280d040"
import script from "./item-mcq-mmcq.vue?vue&type=script&lang=js"
export * from "./item-mcq-mmcq.vue?vue&type=script&lang=js"

import "./item-mcq-mmcq.vue?vue&type=style&index=0&id=e280d040&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__